import React from "react";
import styles from "./SelectRole.module.css";
import { Box, TextComponent } from "../../../../components";
import ClientIcon from "../../../../assets/clienticon.png";
import VendorIcon from "../../../../assets/vendorIcon.png";
import GuestIcon from "../../../../assets/guestIcon.png";
import { useNavigate } from "react-router-dom";

const SelectRole = () => {
  const roles = [
    {
      name: "Client",
      img: ClientIcon,
    },
    {
      name: "Vendor",
      img: VendorIcon,
      background: true,
    },
    {
      name: "Guest",
      img: GuestIcon,
    },
  ];
  const navigation = useNavigate();
  return (
    <div className={styles.mainCont}>
      <div>
        <TextComponent text={"Who are you?"} textClass={styles.subHeadText} />
      </div>
      <div className={styles.roleMainContainer}>
        {roles.map((role) => (
          <Box
            boxClass={styles.roleContainer}
            onClick={() =>
              navigation("/signup", { state: { role: role.name } })
            }
          >
            <img
              src={role.img}
              alt="Client Icon"
              className={styles.roleIcon}
              style={role.name == "Client" ? { width: "75px" }:{}}
            />
            <TextComponent text={role.name} textClass={styles.roleTitle} />
          </Box>
        ))}
      </div>
    </div>
  );
};

export default SelectRole;
